<template>
   <div class="ruler" :class="position">

      <ul v-for="i in groupCount" :key="i">
         <li class="small-tick">
         </li>
         <li class="small-tick">
         </li>
         <li class="small-tick">
         </li>
         <li class="long-tick">
            <div class="ruler-text">{{getNum(i)}}</div>
         </li>
      </ul>
   </div>
</template>

<script>
const START_NUM = 200;
const INTERVAL = 100;

export default {
   data() {
      return {
         num: START_NUM
      }
   },

   props: {
      range: Number,
      position: String
   }, 

   computed: {
      groupCount() {     
         return Math.ceil(this.range / INTERVAL);
      },
   },

   methods: {
      getNum(index) {
         if (index !== 1) {
            return this.num + (INTERVAL * (index-1));
         } else {
            return this.num;
         }
      }
   }
}
</script>

<style lang="scss" scoped>
.ruler {

   border-left: 1px solid white;
   border-top: 1px solid white;

   &.left {
      width: 25px;
      height: 800px;
      float: left;
      background: #2c405a;
      position: relative;
      bottom: 25px;
      border-bottom: 1px solid white;

      li {
         height: 10px;
         border-bottom: 1px solid white;

         &.small-tick {
            width: 6px;
         }

         &.long-tick {
            width: 12px;
         }
      }

      .ruler-text {
         transform: rotate(270deg);
         left: 8px;
         bottom: 6px;
      }
   }

   &.top {
      width: calc(100% - 25px);
      height: 25px;
      background: #2c405a;
      display:flex;
      margin-left: 25px;
      border-right: 1px solid white;

      ul {
         display: flex;

         &:first-child {
            margin-left: 10px;
         }
      }

      li {
         width: 10px;
         border-left: 1px solid white;

         &.small-tick {
            height: 6px;
         }

         &.long-tick {
            height: 12px;
         }
      }
      
      .ruler-text {
         top: 7px;
         left: 3px;
      }
   }
   
   ul {
      margin: 0;
      padding: 0;
      list-style: none;
      
   }
     
   .ruler-text {
      font-size: 9px;
      color: #798a98;
      position: relative;
   }
}
</style>
